import { Icon, IconProps } from '@chakra-ui/react'

export default function TicketIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M2.66699 10.0013V11.3346C2.66699 12.8074 3.8609 14.0013 5.33366 14.0013H10.229C10.9363 14.0013 11.6146 13.7203 12.1148 13.2202L13.2193 12.1157C13.7194 11.6156 14.0003 10.9373 14.0003 10.2301V5.33464C14.0003 3.86188 12.8064 2.66797 11.3337 2.66797H10.0003"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14V11.3333C10 10.597 10.597 10 11.3333 10H14"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="2"
        width="6"
        height="6"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9375 6.0013H4.0625"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9375 4.0013H4.0625"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
